import {
	INIT_COMPARE,
	ADD_TO_COMPARE,
	REMOVE_FROM_COMPARE,
	UPDATE_COMPARE,
	REMOVE_ALL
} from '../constants/compareConstants';
import { logout } from 'actions/LoginSignupActions/logoutActions';
import { getObject, setObject, removeObject } from 'utils/localStorage';

export default function compare(state = [], action = null) {
	let newState = [];
	switch (action.type) {
		case INIT_COMPARE:
			const storedState = getObject('fk-compare-data');
			newState = (state.length === 0 && storedState) || state;
			break;
		case ADD_TO_COMPARE:
			const isPresent =
				state.length &&
				state.reduce((isPresent, product) => {
					return product.value.id === action.data.value.id;
				}, false);
			newState = isPresent ? state : [...state, action.data];
			setCompareData(newState);
			break;
		case REMOVE_FROM_COMPARE:
			newState = state.filter(product => {
				return product.value.id !== action.data.value.id;
			});
			setCompareData(newState);
			break;
		case UPDATE_COMPARE:
			newState = action.data;
			break;
		case REMOVE_ALL:
			newState = [];
			setCompareData(newState);
			break;
		case logout.LOGOUT_REQUEST:
			removeCompareData();
			break;
		default:
			newState = state;
	}
	return newState;
}

function setCompareData(newState) {
	setTimeout(function () {
		setObject('fk-compare-data', newState);
	}, 0);
}

function removeCompareData() {
	setTimeout(function () {
		removeObject('fk-compare-data');
	}, 0);
}
